import { Blocks as ItemCellBlocks, TypeConfig as ItemCellTypeConfig } from './ItemCell.jsx';
import { Tokens as ItemCellMetaTokens } from './ItemCellMeta.jsx';
import * as ItemsList from './ItemsList.jsx';
import * as ListTitle from '../common/ListTitle.jsx';
import Name from '../utility/Name.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'pricelistSeparator',
            dataType: 'separator',
            display: 'Pricelist',
            group
        },
        {
            id: Name.Block.ListTitle,
            component: ListTitle.Component,
            config: {
                Block: ListTitle.TypeConfig.panel.block(),
                Visibility: ListTitle.TypeConfig.panel.visibility({ configurableDuringExport: (type) => type == Name.Config.Pricelist }),
                Style: ListTitle.TypeConfig.panel.style()
            },
            display: 'List Title\n(Quicklists Only)',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: ItemsList.Component,
            config: {
                Block: ItemsList.TypeConfig.panel.block(),
                Style: ItemsList.TypeConfig.panel.style(),
                Visibility: ItemsList.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ItemCellTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Items List',
            group,
            image: ''
        }
    ]
};
const Content = {
    [Name.Block.Inventory.List]: ItemCellBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Inventory.Meta:
            case Name.Block.ListOrderNumber:
                return ItemCellMetaTokens(data);
            case Name.Block.ListTitle:
                return ListTitle.Tokens();
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}